import React, { HTMLAttributes } from 'react';
import Box from '@mui/material/Box';

const scaleMap = {
  xs: 0.5,
  s: 1,
  m: 2,
  l: 3,
  xl: 4,
} as const;

type InsetProps = {
  scale?: 'xs' | 's' | 'm' | 'l' | 'xl';
  children: React.ReactNode;
  className?: string;
} & HTMLAttributes<HTMLDivElement>;

const Inset = ({ children, scale = 'm', className, ...props }: InsetProps) => (
  <Box className={className} sx={{ p: scaleMap[scale] }} {...props}>
    {children}
  </Box>
);

export default Inset;
